// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"3790":"011222a6","5761":"3706716d","8842":"4b64e53b"}[chunkId] || chunkId) + "." + {"658":"1e967636a735024f","2823":"b95ca99203875c87","3790":"e2550403d52a7f2d","5761":"a5044d81c7fae796","8842":"3a8788e83d343406"}[chunkId] + ".js";
};